import GTMAuthActionsEventsMiddleware from './GTMAuthActionsEvents.middleware'
import GTMSupportActionsEventsMiddleware from './GTMSupportActionsEvents.middleware'
import GTMProjectActionsEventsMiddleware from './GTMProjectActionsEvents.middleware'
import GTMProductActionsEventsMiddleware from './GTMProductActionsEvents.middleware'

export default {
	...GTMAuthActionsEventsMiddleware,
	...GTMSupportActionsEventsMiddleware,
	...GTMProjectActionsEventsMiddleware,
	...GTMProductActionsEventsMiddleware
}
